import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalIdentificationSection() {
  const situations = ['Evitas iniciar relaciones por miedo a fallar.', 'Te preocupa perder la erección en el momento más importante.', 'Terminas antes de lo que quisieras.', 'Te cuesta relajarte durante el encuentro.', 'Tu confianza ya no es la misma.', 'Piensas demasiado durante la intimidad.'];
  return <section className="relative w-full bg-black py-10 md:py-14 overflow-hidden" data-id="element-117">
      <div className="absolute inset-0 z-0" data-id="element-118">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-red-800/15 blur-[150px]" data-id="element-119" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-120" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-121" />

      <div className="relative z-20 max-w-4xl mx-auto px-6" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-123">
          <h2 className="font-display text-3xl md:text-5xl uppercase mb-8 text-center text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-124">
            ¿Te reconoces en alguna de estas situaciones?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-125">
            {situations.map((situation, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/40 rounded-xl px-5 py-4 flex items-center gap-3 shadow-[0_0_15px_rgba(220,38,38,0.05)]" data-id="element-126">
                <span className="text-red-500 text-xl flex-shrink-0 drop-shadow-[0_0_6px_rgba(220,38,38,0.5)]" data-id="element-127">
                  ✔
                </span>
                <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-128">
                  {situation}
                </span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6,
          duration: 0.6
        }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/50 p-6 md:p-8 rounded-lg shadow-[0_0_40px_rgba(220,38,38,0.1)] overflow-hidden text-center" data-id="element-129">
            <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-red-600" data-id="element-130" />
            <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-red-600" data-id="element-131" />
            <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-red-600" data-id="element-132" />
            <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-red-600" data-id="element-133" />

            <p className="text-lg md:text-xl text-gray-300" data-id="element-134">
              Si respondiste <span className="text-white font-bold" data-id="element-135">"sí"</span>{' '}
              a una o más de estas situaciones, no estás solo.{' '}
              <span className="text-red-400 font-bold" data-id="element-136">
                Miles de hombres pasan por lo mismo.
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}